import React from 'react';
import { errosVisiveisNoAlerta, idCampoAlvoInternacional, textoColunaRecolhida } from './validacaoInternacionalPolicy';

// Faixa laranja "Corrija os dados internacionais para salvar" (acima do rodapé do orçamento).
// Item 13: cada pendência com campo na grade tem o seu "Mostrar campo"; câmbio mantém "Informar câmbio".
// O botão age no mousedown com preventDefault: se um campo da grade ainda está focado (valor apagado
// e não confirmado), ele não perde o foco antes da ação — o blur confirmaria o valor, o alerta
// ganharia uma linha, cresceria para cima e o botão sairia de baixo do cursor no meio do clique.
// onClick fica só para teclado (Enter/Espaço disparam click com detail 0).
// `titulo` (21/10): a mesma faixa serve à observação obrigatória ("Preencha a observação para salvar:").
// `onAcao` (21/10): pendência com `acao: { rotulo }` ganha um botão próprio (ex.: "Incluir ART").
export default function AlertaDadosInternacionais({ erros = [], colunasVisiveis = {}, onMostrarCampo, onInformarCambio, onAcao, titulo = 'Corrija os dados internacionais para salvar:' }) {
    const { visiveis, ocultos } = errosVisiveisNoAlerta(erros);
    return (
        <div role="alert" style={{ padding: '10px 18px', background: '#fff7ed', borderTop: '1px solid #fdba74', color: '#9a3412', boxShadow: '0 -2px 8px rgba(154,52,18,.08)' }}>
            <div className="d-flex align-items-start justify-content-between gap-3">
                <div style={{ flex: 1, minWidth: 0 }}>
                    <strong>{titulo}</strong>
                    <ul className="mb-0 mt-1 ps-3">
                        {visiveis.map((erro, index) => {
                            const recolhida = textoColunaRecolhida(erro.alvo, colunasVisiveis);
                            const idAlvo = idCampoAlvoInternacional(erro.alvo);
                            return (
                                <li key={`${erro.tipo}-${index}`}>
                                    <div className="d-flex align-items-center justify-content-between gap-3" style={{ minHeight: 30 }}>
                                        <span>
                                            {erro.mensagem}
                                            {recolhida && <>{' '}<em style={{ opacity: 0.85 }}>{recolhida}</em></>}
                                        </span>
                                        {erro.acao && onAcao && (
                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm flex-shrink-0" style={{ padding: '4px 10px' }}
                                                data-acao="incluir-item-obrigatorio" onClick={() => onAcao(erro)}>{erro.acao.rotulo}</button>
                                        )}
                                        {idAlvo && (
                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm flex-shrink-0" style={{ padding: '4px 10px' }}
                                                data-acao="mostrar-campo-internacional" data-alvo={idAlvo}
                                                title={recolhida ? 'Expande a coluna recolhida e leva ao campo pendente' : 'Leva ao campo pendente na grade'}
                                                onMouseDown={(e) => { if (e.button !== 0) return; e.preventDefault(); onMostrarCampo(erro.alvo); }}
                                                onClick={(e) => { if (e.detail === 0) onMostrarCampo(erro.alvo); }}>Mostrar campo</button>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                        {ocultos > 0 && (
                            <li style={{ listStyle: 'none', fontStyle: 'italic' }}>
                                + {ocultos} {ocultos === 1 ? 'pendência' : 'pendências'} — aparecem conforme as de cima forem corrigidas.
                            </li>
                        )}
                    </ul>
                </div>
                {erros.some((erro) => erro.tipo === 'cambio') && (
                    <button type="button" className="btn btn-sm btn-outline-warning flex-shrink-0" onClick={onInformarCambio}>Informar câmbio</button>
                )}
            </div>
        </div>
    );
}
